import { Button } from '@shared/components/ui/button';
import { EmptyView, EMPTY_VIEW_ICONS } from '@shared/components/ui/EmptyView';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreatePackagingButton } from '../interaction';
import { PackagingGridSkeleton } from '../skeletons';

interface PackagingStatesProps {
  isLoading: boolean;
  error: unknown;
  filteredItemsCount: number;
  apiItemsCount: number;
  searchTerm: string;
  hasLocalFilters: boolean;
  /** Si el infinite query aún puede traer más ítems de /packaging */
  hasNextPage: boolean;
  onRefetch: () => void;
  onCreatePackaging: () => void;
}

const PackagingStates: React.FC<PackagingStatesProps> = ({
  isLoading,
  error,
  filteredItemsCount,
  apiItemsCount,
  searchTerm,
  hasLocalFilters,
  hasNextPage,
  onRefetch,
  onCreatePackaging,
}) => {
  const { t } = useTranslation('materialAlmacenModule');

  if (isLoading && apiItemsCount === 0) {
    return <PackagingGridSkeleton />;
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-destructive mb-4">{t('errors.network')}</p>
        <Button onClick={onRefetch} variant="outline" size="sm" data-testid="refetch-button">
          {t('button.loading')}
        </Button>
      </div>
    );
  }

  if (!isLoading && !error && filteredItemsCount === 0) {
    // Mientras el infinite query pueda traer más datos, no bloqueamos con EmptyView (sentinela en el grid)
    if (hasNextPage) {
      return null;
    }

    const noResultsFromSearchOrFilters = Boolean(searchTerm?.trim()) || (hasLocalFilters && apiItemsCount > 0);

    return (
      <EmptyView
        type={noResultsFromSearchOrFilters ? 'noResults' : 'emptyState'}
        icon={EMPTY_VIEW_ICONS.ORDER_PREPARATION}
        customAction={
          noResultsFromSearchOrFilters ? null : <CreatePackagingButton onCreatePackaging={onCreatePackaging} />
        }
      />
    );
  }

  return null;
};

export default PackagingStates;
